<template>
    <div class="container py-5">
        <h1>Unidades</h1>
        <p>Conteúdo da página de Unidades</p>
    </div>
</template>

<script>
export default {
  name: 'UnidadesPage',
};
</script>

<style scoped>
/* estilos específicos do componente */
</style>